var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 15.0126V6.625C14.875 6.14175 14.4832 5.75 14 5.75C13.5168 5.75 13.125 6.14175 13.125 6.625V15.0126L10.2437 12.1313C9.90201 11.7896 9.348 11.7896 9.00629 12.1313C8.66457 12.473 8.66457 13.027 9.00629 13.3687L14 18.3624L18.9938 13.3687C19.3354 13.027 19.3354 12.473 18.9938 12.1313C18.652 11.7896 18.098 11.7896 17.7562 12.1313L14.875 15.0126Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.125C7.48325 17.125 7.875 17.5168 7.875 18V19.4C7.875 20.0766 8.42345 20.625 9.1 20.625H18.9C19.5766 20.625 20.125 20.0766 20.125 19.4V18C20.125 17.5168 20.5168 17.125 21 17.125C21.4832 17.125 21.875 17.5168 21.875 18V19.4C21.875 21.0431 20.5431 22.375 18.9 22.375H9.1C7.45696 22.375 6.125 21.0431 6.125 19.4V18C6.125 17.5168 6.51675 17.125 7 17.125Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a7f7466062d3648baf09a67df8bf3ffe.svg";
export { ForwardRef as ReactComponent };